import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import useDivisions from '~/modules/common/enhancers/useDivisions';
import { ScopeObjectType } from '~/types';
import { POLICYTYPE } from '~/modules/common/enums';
import { onChange } from '../enhancers/facetHelpers';

import GroupFacetDetails from '../GroupFacetDetails';

export const DivisionFacetDetails = ({
  className,
  selected,
  setSelected,
  policy = POLICYTYPE.PROJECT_MANAGEMENT,
  scope
}) => {
  const { formatMessage } = useIntl();
  const [searchTerm, setSearchTerm] = useState('');
  const noneOptionText = formatMessage({
    id: 'divisionDropdown.noDivision'
  });
  const { divisions, loading, hasMore } = useDivisions({
    searchTerm,
    policy,
    includeNoneOption: true,
    noneOptionText,
    scope
  });

  return (
    <GroupFacetDetails
      label={formatMessage({ id: 'search.division' })}
      className={className}
      selected={selected}
      onChange={onChange}
      setSelected={setSelected}
      isLoading={loading}
      setSearchTerm={setSearchTerm}
      options={divisions}
      noOptionsLabel={formatMessage({ id: 'divisionDropdown.noDivision' })}
      hasMore={hasMore}
      optionTypeText={formatMessage({
        id: 'moreOptions.division'
      })}
    />
  );
};

DivisionFacetDetails.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  scope: PropTypes.oneOf(Object.values(ScopeObjectType)),
  policy: PropTypes.oneOf([
    POLICYTYPE.PORTFOLIO_MANAGEMENT,
    POLICYTYPE.PROJECT_MANAGEMENT,
    POLICYTYPE.RESOURCE_MANAGEMENT,
    POLICYTYPE.REVENUE_MANAGEMENT
  ])
};

export default DivisionFacetDetails;
